let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hfcJ4")).then(() => parcelRequire('9EVQy'));